<template>
	<v-list dense class="manager-drawer-group">
		<h3 class="subheader">{{ title }}</h3>
		<manager-drawer-item v-for="tab in visibleTabs" :key="tab.html" :tab="tab" @selectTab="selectTab" :is-tab-selected="isTabSelected(tab)" />
	</v-list>
</template>

<script>
import ManagerDrawerItem from './ManagerDrawerItem.vue';

export default {
	props: {
		title: {
			default: 'Menu'
		},
		tabs: {
			default: function() {
				return [];
			}
		},
		activeTab: {
			default: function() {
				return null;
			}
		}
	},
	computed: {
		visibleTabs() {
			return this.tabs.filter(tab => tab.visible);
		}
	},
	methods: {
		selectTab: function(tab) {
			this.$emit('activeTab', tab);
		},
		isTabSelected: function(tab) {
			return tab == this.activeTab || (window.getCurrentUrlPath && window.getCurrentUrlPath() == tab.html);
		}
	},
	components: {
		ManagerDrawerItem
	}
};
</script>

<style>
.manager-drawer-group .system-outage .v-list-item__icon > i {
	color: orange;
}

.manager-drawer-group .subheader {
	font-size: 1rem;
	margin: .75rem 16px;
}
</style>